import { styled } from "@mui/system";
import {
  GridApi,
  gridColumnDefinitionsSelector,
  GridToolbarContainer,
  GridToolbarFilterButton,
  gridVisibleColumnDefinitionsSelector,
  useGridApiContext,
} from "@mui/x-data-grid";
import { CreateButton } from "./CreateButton";
import UploadButton from "./UploadButton";
import React, { Dispatch, FC, SetStateAction } from "react";
import DownloadVehiclesButton from "./DownloadVehiclesButton";
import { Button, Fade } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ViewColumn as ViewColumnIcon } from "@mui/icons-material/";
import ExpandContainerButton from "../../../common/small-screen/ExpandContainerButton";

interface ToolbarProps {
  setFilterButtonEl: Dispatch<SetStateAction<HTMLButtonElement | null>>;
  setDisplayAll: Dispatch<SetStateAction<boolean>>;
  displayAll: boolean;
}

const Toolbar: FC<ToolbarProps> = ({
  setFilterButtonEl,
  displayAll,
  setDisplayAll,
}) => {
  const apiRef = useGridApiContext<GridApi>();
  const { t } = useTranslation();
  const visibleColumnsLength = gridVisibleColumnDefinitionsSelector(
    apiRef
  ).filter(
    (column) => column.type !== "actions" && column.type !== "checkboxSelection"
  ).length;

  const onShowAll = () => {
    const columns = gridColumnDefinitionsSelector(apiRef).map((col) =>
      col.hideable !== false ? { field: col.field, hide: false } : col
    );
    apiRef.current.updateColumns(columns);
  };

  return (
    <Wrapper>
      <Fade in={visibleColumnsLength === 0}>
        <Button
          variant="outlined"
          size="medium"
          color="secondary"
          onClick={onShowAll}
          startIcon={<ViewColumnIcon />}
        >
          {t("table.show.columns")}
        </Button>
      </Fade>
      <GridToolbarFilterButton ref={setFilterButtonEl} />
      <UploadButton />
      <DownloadVehiclesButton />
      <CreateButton />
      <ExpandContainerButton
        setDisplayAll={setDisplayAll}
        displayAll={displayAll}
      />
    </Wrapper>
  );
};

const Wrapper = styled(GridToolbarContainer)(({ theme }) => ({
  justifyContent: "flex-end",
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
  [theme.breakpoints.up("sm")]: {
    flexDirection: "row",
  },
}));

export default Toolbar;
